var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-loader"},[_c('i',{staticClass:"la la-spinner la-spin",style:({ fontSize: _vm.size + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }